import RequestsKanbanBoardReducer from './RequestsKanbanBoardReducer';

export default from './RequestsKanbanBoardContainer';

export const RequestsKanbanBoardReducers = {
  RequestsKanbanBoardReducer,
};
